import { useContext } from 'react'

import ChatContext from './Context'

export default () => useContext(ChatContext)
